import { cloneElement, useEffect, useState } from "react";
import { FiChevronDown, FiChevronUp, FiLogOut } from "react-icons/fi";
import { IoChevronForward } from "react-icons/io5";
import { useDispatch } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { routes } from "routes";
import { signOutRequest } from "../../../store/auth/authSlice";
import { Button } from "../Button";
import classes from "./SideBar.module.css";
import { logo, sidebar_bg } from "constant/imagePath";
import { billingRoutes } from "constant/constants";
import { isInternalSchool } from "helper/HelperFunction";
import { useSelector } from "react-redux";

const SideBar = ({ isCollapsed, setIsCollapsed, isMobile }) => {
  const { user } = useSelector((state) => state.authReducer);
  const isInternal = isInternalSchool(user);
  const [popper, setPopper] = useState(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const HandleSubmitSignOut = () => {
    dispatch(signOutRequest());
    navigate("/login");
  };

  return (
    <div
      className={classes?.mainContainer}
      style={{ "--bg-image": `url(${sidebar_bg})` }}
    >
      <div className={classes?.logoContainer}>
        {isCollapsed ? (
          <div className={classes.logoIcon} onClick={() => navigate("/")}>
            <img src={logo} height={20} alt="abc" />
          </div>
        ) : (
          <div className={classes.logo} onClick={() => navigate("/")}>
            <img src={logo} height={20} alt="abc" />
          </div>
        )}
      </div>
      <div
        className={classes.toggler}
        onClick={() => setIsCollapsed((prev) => !prev)}
      >
        <IoChevronForward
          className={!isCollapsed ? classes.toggleIcon : ""}
          cursor={"pointer"}
        />
      </div>
      <div
        className={[
          classes.itemsContainer,
          isCollapsed && classes.isCollapsedContainer,
          isMobile && classes.isMobile,
        ].join(" ")}
      >
        {isCollapsed && popper && (
          <span
            className={classes.popper}
            style={{ top: `${popper.pos + 16}px` }}
          >
            {popper.value}
          </span>
        )}
        <div
          className={[
            classes.items,
            isCollapsed && classes.itemsCollapsed,
          ].join(" ")}
        >
          {routes
            .filter(
              (e) =>
                e.showInSidebar &&
                // An internal school never buys a bundle or credits, so the
                // billing entries would only lead to dead ends.
                !(isInternal && billingRoutes.includes(e.path))
            )
            .map((item, index) => {
              const hasPermission = item.permission?.includes(user?.role);
              const subMenuHasPermission = item.subMenu?.some((e) =>
                e.permission?.includes(user?.role)
              );
              return hasPermission || subMenuHasPermission ? (
                <RenderItem
                  icon={item?.icon}
                  title={item?.title}
                  path={item?.path}
                  subMenu={
                    item?.subMenu &&
                    item.subMenu.filter(
                      (e) =>
                        e.showInSidebar && e.permission?.includes(user?.role)
                    )
                  }
                  isCollapsed={isCollapsed}
                  key={index}
                  setPopper={setPopper}
                />
              ) : (
                ""
              );
            })}
        </div>
        {/* <Button
          className={[
            classes["logout-btn"],
            isCollapsed ? classes["collapsed-btn"] : "",
          ].join(" ")}
          variant="link"
          onClick={HandleSubmitSignOut}
        >
          <FiLogOut />
          {!isCollapsed && "Logout"}
        </Button> */}
      </div>
    </div>
  );
};

export default SideBar;

const RenderItem = ({
  icon,
  title,
  subMenu = [],
  path,
  isCollapsed,
  setPopper,
}) => {
  const pathname = useLocation()?.pathname;
  const active = pathname === path ? true : false;
  const [subnav, setSubnav] = useState(false);
  const subActive = subMenu.find((item, index) => item?.path == pathname);
  const showSubnav = () => setSubnav(!subnav);
  useEffect(() => {
    const allPaths = subMenu.map((item) => item?.path);
    if (allPaths.includes(pathname)) {
      setSubnav(true);
    }
  }, []);

  return (
    <>
      <Link
        className={[
          classes?.listItemContainer,
          (active || subnav) && classes?.active,
          subActive && classes?.subActive,
          subnav &&
            [isCollapsed ? classes?.isCollapsedSubnav : classes.subnav].join(
              " "
            ),
          isCollapsed ? classes.isCollapsed : "",
        ].join(" ")}
        onMouseEnter={(e) => {
          setPopper({
            pos: e.target.offsetTop - e.target.parentElement.scrollTop,
            value: title,
          });
        }}
        onMouseLeave={(e) => {
          setPopper(null);
        }}
        data-title={title}
        to={subMenu?.length > 0 ? "#" : path}
        onClick={() => {
          if (subMenu?.length > 0) {
            showSubnav(!subnav);
          }
        }}
      >
        {icon
          ? cloneElement(icon, {
              size: 20,
              className: classes?.icon,
            })
          : null}
        {!isCollapsed && <span>{title}</span>}
        {subMenu?.length > 0 &&
          !isCollapsed &&
          (!subnav ? (
            <FiChevronDown size={18} className={classes?.dropDownIcon} />
          ) : (
            <FiChevronUp size={18} className={classes?.dropDownIcon} />
          ))}
      </Link>

      {subnav && (
        <div
          className={[
            classes?.subMenu,
            isCollapsed ? classes.submenuIsCollapsed : "",
          ].join(" ")}
        >
          {subMenu.map((item, index) => {
            return (
              <Link
                to={item?.path}
                className={[
                  classes?.innerItemContainer,
                  isCollapsed
                    ? classes.isCollapsed
                    : classes?.notCollapsedInnercontainer,
                  subActive?.path === item?.path && classes?.innerItemSubActive,
                ].join(" ")}
                onMouseEnter={(e) => {
                  setPopper({
                    pos:
                      e.target.offsetTop +
                      e.target.parentElement.offsetTop -
                      e.target.parentElement.parentElement.scrollTop -
                      10,
                    value: item?.title,
                  });
                }}
                onMouseLeave={(e) => {
                  setPopper(null);
                }}
                data-title={item?.title}
                key={index}
              >
                {item?.icon &&
                  isCollapsed &&
                  cloneElement(item?.icon, {
                    size: 16,
                    className: classes.innerIcon,
                  })}

                {!isCollapsed && <span>{item?.title}</span>}
              </Link>
            );
          })}
        </div>
      )}
    </>
  );
};
